import basicTheme from '../basicTheme.js';

const accordionDetailsStyleOverrides = {
    styleOverrides: {
        root: {
            padding: 0,
            background: basicTheme.palette.N70.main,
            margin: '0 8px 8px 8px',
        },
    },
};

export { accordionDetailsStyleOverrides as default };
//# sourceMappingURL=MuiAccordionDetails.js.map
